import React from 'react'

import CMS from '@talus-analytics/library.airtable-cms'
import useIndexPageData from '../../../cmsHooks/useIndexPageData'

import { FullWidthSection, ContentContainer, Center } from 'components/layout'
import Feature from './how/Feature'

const HowItWorksSection = (): JSX.Element => {
  const data = useIndexPageData()

  return (
    <FullWidthSection darker>
      <ContentContainer>
        <Center cross>
          <h2>
            <CMS.Text name="How it works headline" data={data} />
          </h2>
        </Center>
        <Feature number={'1'} imageOn={'right'} />
        <Feature number={'2'} imageOn={'left'} />
        <Feature number={'3'} imageOn={'right'} />
        <Feature number={'4'} imageOn={'left'} />
        <Feature number={'5'} imageOn={'right'} />
      </ContentContainer>
    </FullWidthSection>
  )
}

export default HowItWorksSection
